import '../styles.scss';
import React from 'react';
import Chart from 'react-apexcharts';
// import lineBreaker from 'helpers/LineBreaker';
import SemDados from '../SemDados';

const EvolucaoCanal = (props) => {
  const { data } = props;
  const titulo = 'EVOLUÇÃO POR CANAL';

  if (!data || Object.keys(data).length === 0)
    return <SemDados titulo={titulo} />;

  const canais = Object.keys(data);
  const anos = Object.keys(data[canais[0]].data);
  let maxValue = 1;

  const calculateAnnotation = (series) => {
    const tmpAnnotationPoints = [];

    canais.forEach((canal) => {
      if (anos.length < 2) return;
      const dataUltimoAno = series[anos.length - 1].data[canais.indexOf(canal)];
      const dataPenultimoAno =
        series[anos.length - 2].data[canais.indexOf(canal)];
      const variacaoCanal =
        ((dataUltimoAno - dataPenultimoAno) / dataPenultimoAno) * 100;
      const labelColor = variacaoCanal > 0 ? '#008000' : '#FF0000';

      tmpAnnotationPoints.push({
        x: canal,
        y: series[anos.length - 1].data[canais.indexOf(canal)],
        marker: {
          size: 0,
        },
        label: {
          borderColor: undefined,
          text: Number.isFinite(variacaoCanal)
            ? `${variacaoCanal > 0 ? '+' : ''}${variacaoCanal.toFixed(0)}% ${
                variacaoCanal > 0 ? '↑' : '↓'
              }`
            : 'N/A',
          textAnchor: 'start',
          offsetX: 0,
          offsetY: -25,
          style: {
            background: 'transparent',
            color: labelColor,
            fontSize: '0.9rem',
            fontWeight: 700,
          },
        },
      });
    });
    return tmpAnnotationPoints;
  };

  const calculateSeries = () => {
    if (anos.length === 0) {
      return [];
    }

    const tmpSeries = [];

    anos.forEach((ano) => {
      tmpSeries.push({
        name: ano,
        data: canais.map((canal) => {
          const sum = data[canal].data[ano].reduce((a, b) => a + b, 0);
          maxValue = Math.max(maxValue, sum);
          return sum;
        }),
      });
    });

    return tmpSeries;
  };

  const series = calculateSeries();
  const options = {
    annotations: {
      points: calculateAnnotation(series),
    },
    colors: ['#faa306', '#1374fb'],
    legend: {
      showForSingleSeries: true,
      formatter: (seriesName) => {
        return [seriesName.toUpperCase()];
      },
      show: true,
      position: 'bottom',
      horizontalAlign: 'center',
      floating: false,
      offsetX: 0,
      offsetY: 6,
    },
    plotOptions: {
      bar: {
        hideZeroBarsWhenGrouped: false,
        horizontal: false,
        dataLabels: {
          position: 'top',
        },
        colors: {},
      },
    },
    stroke: {
      colors: ['transparent'],
      width: 4,
    },
    xaxis: {
      categories: [...canais],
      show: true,
      labels: {
        show: true,
        offsetY: 0,
        style: {
          fontWeight: 600,
        },
        formatter: (value) => {
          const lines = value.toUpperCase();
          return lines;
        },
      },
      axisBorder: {
        show: true,
      },
      axisTicks: {
        show: true,
      },
    },
    yaxis: {
      max: maxValue * 1.2,
      show: false,
    },
    grid: {
      show: true,
      xaxis: {
        lines: {
          show: true,
        },
      },
      yaxis: {
        lines: {
          show: false,
        },
      },
    },
    chart: {
      id: 'can-solicitacoes',
      parentHeightOffset: 5,
      toolbar: {
        show: true,
      },
    },
    dataLabels: {
      hideOverflowingLabels: false,
      textAnchor: 'middle',
      offsetX: 0,
      offsetY: -19,
      formatter: (value) => {
        return value === null ? '0' : `${value}`;
      },
      style: {
        fontSize: '12px',
        fontWeight: 'bold',
        colors: ['#373d3f'],
      },
    },
    tooltip: {
      shared: false,
      followCursor: true,
      onDatasetHover: {
        highlightDataSeries: false,
      },
      // eslint-disable-next-line
      custom: ({ series, seriesIndex, dataPointIndex }) => {
        return `<div class="arrow_box">
            <span>
              Ano: <span id="data">${anos[seriesIndex]}</span>
            </span>
            <span>
              Canal: <span id="data">${canais[
                dataPointIndex
              ].toUpperCase()}</span>
            </span>
            <span>
              Total de Solicitações: <span id="data">${
                series[seriesIndex][dataPointIndex]
              }</span>
            </span>
          </div>
          `;
      },
    },
  };

  return (
    <div className="grafico">
      <div className="grafico-titulo">
        <span>{titulo}</span>
      </div>
      <Chart options={options} series={series} type="bar" height="300" />
    </div>
  );
};

export default EvolucaoCanal;
